module.exports = __webpack_public_path__ + "img/led_in_switch_65_less.9e4d0bfa.png";